export default function CurrencyFormat(props) {
  const currencyFormatted = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
  }).format(props.price);
  return currencyFormatted;
}
